// 認証が必要なルートを保護するコンポーネント

import { useEffect, useState } from 'react';
import { checkAuthStatus, getLoginRedirectUrl } from '../utils/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * 認証が必要なページをラップするコンポーネント
 * 未認証の場合は東商マイページへリダイレクト
 */
export function ProtectedRoute({ children }: ProtectedRouteProps): React.ReactElement | null {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      // ローカル開発環境では認証をスキップ
      const isDevelopment = import.meta.env.DEV;

      // 認証機能が有効な場合のみチェック
      const authEnabled = import.meta.env.VITE_ENABLE_AUTHENTICATION === 'true';

      console.log('[ProtectedRoute] isDevelopment:', isDevelopment);
      console.log('[ProtectedRoute] VITE_ENABLE_AUTHENTICATION:', import.meta.env.VITE_ENABLE_AUTHENTICATION);
      console.log('[ProtectedRoute] authEnabled:', authEnabled);

      if (isDevelopment || !authEnabled) {
        // 開発環境または認証機能が無効の場合は常に認証済みとして扱う
        setIsAuthenticated(true);
        return;
      }

      const authenticated = await checkAuthStatus();

      if (!authenticated) {
        // 未認証の場合は東商マイページへリダイレクト
        const redirectUrl = getLoginRedirectUrl();
        window.location.href = redirectUrl;
      } else {
        setIsAuthenticated(true);
      }
    };

    void checkAuth();
  }, []);

  // 認証チェック中はローディング表示
  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">認証を確認中...</p>
        </div>
      </div>
    );
  }

  // 認証済みの場合は子コンポーネントを表示
  return <>{children}</>;
}
